import React from 'react';

const CTA = () => {
  return (
    <section id='cta'>
      <div className='container tc'>
        <div className='s-64'></div>
        <h3 className='title-sub'>Оволодій професією майбутнього</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Почни заробляти на гідне життя
        </h4>
        <div className='s-48'></div>
        <div className='card tl b-none p-5'>
          <div className='m-5'>
            <div className='row'>
              <div className='col-lg-6'>
                <h3 className='title-sub w-100' style={{ lineHeight: 1.2 }}>
                  Обери напрямок навчання прямо зараз
                </h3>
                <div className='s-32'></div>
                <p className='title-card flex aic'>
                  <span>⭐</span>
                  <span className='px-2 pt-1'>Займе всього 7 хвилин</span>
                </p>
                <div className='s-40'></div>
                <a href='/ua' className='button'>
                  Підібрати напрямок
                </a>
              </div>
              <div className='col-lg-6'></div>
            </div>
          </div>
        </div>
        <div className='s-80'></div>
      </div>
    </section>
  );
};

export { CTA }; 